<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >

    <b-card>
      <div>
        <b-row>
          <b-col>
            <dashboard-alert
              variant="info"
              :title="$t('fiatWidraw.description')"
              :description="$t('fiatWidraw.text')"
              :btn-text="$t('fiatWidraw.buttontxt')"
              :btn-to="`/${$i18n.locale}/document/bank`"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <dashboard-alert
              v-if="balance != null"
              variant="success"
            >
              <div class="d-flex justify-content-between">
                <h4 class="">
                  {{ $t('fiatWidraw.totalBalance') }}
                </h4>
                <h4
                  class=""
                  dir="ltr"
                >
                  {{ helpers.numberWithCommas(balance) }}
                </h4>
              </div>
            </dashboard-alert>
            <validation-observer ref="simpleRules">
              <b-form class="auth-forgot-password-form mt-2">
                <b-row>
                  <b-col
                    cols="12"
                    md="4"
                  >
                    <b-form-group
                      label-for="currency"
                      :label="$t('fiatWidraw.currency')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        vid="currency"
                        :name="$t('fiatWidraw.currency')"
                        rules="required"
                      >
                        <v-select
                          id="currency"
                          v-model="token"
                          :options="currencies"
                          :placeholder="$t('fiatWidraw.select')"
                          label="token"
                          track-by="name"
                          :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                          @input="onchangeCurrency"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    md="4"
                  >
                    <b-form-group
                      :label="$t('fiatWidraw.amount')"
                      label-for="amount"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('fiatWidraw.amount')"
                        rules="required"
                      >
                        <b-form-input
                          v-model="amount"
                          name="amount"
                          :placeholder="`${$t('fiatWidraw.amount')}...`"
                          autocomplete="nope"
                          :formatter="numberFormat"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    md="4"
                  >
                    <b-form-group
                      label-for="event-importance"
                      :label="$t('widrawModal.iban')"
                      class="right-selector"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('widrawModal.iban')"
                        rules="required"
                      >
                        <v-select
                          id="event-importance"
                          v-model="iban"
                          :options="ibans"
                          :placeholder="$t('fiatWidraw.select')"
                          label="iban"
                          :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                          track-by="name"
                        >
                          <template
                            #option="item"
                          >
                            <div>
                              <span>{{ $t('iban') }} : {{ item.iban }}</span>
                              <br>
                              <span>{{ $t('card_numbers') }} : {{ item.numbers }}</span>
                            </div>
                          </template>
                        </v-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
            <b-row>
              <b-col cols="12">
                <p
                  v-if="parseFloat(amount.replace(/,/g, '')) > parseFloat(balance.replace(/,/g, ''))"
                  class="text-danger"
                >
                  {{ $t('disabledBtnText') }}
                </p>
              </b-col>
              <b-col
                cols="12"
                class="d-flex justify-content-end"
              >
                <b-button
                  data-toggle="modal"
                  data-target="#myModal"
                  variant="primary"
                  pill
                  class=""
                  :disabled="parseFloat(amount.replace(/,/g, '')) > parseFloat(balance.replace(/,/g, ''))"
                  @click="showModal()"
                >
                  <span v-if="!submitLoading">{{ $t('send') }}</span>
                  <div v-if="submitLoading">
                    <b-spinner
                      small
                      type="grow"
                    />
                    <span>{{ $t('loading') }}</span>
                  </div>
                </b-button>

                <Receipt
                  :show-internal-withdraw-warning="false"
                  :visible="showReceipt"
                  :date="new Date().toUTCString()"
                  :currency="token.token"
                  :amount="helpers.numberWithCommas(amount) + ' ' + token.token"
                  :iban="iban.iban"
                  :token="token"
                  :fee="token.fee ? helpers.numberWithCommas(token.fee) + ' ' + token.token : '0 ' + token.token"
                  :total=" helpers.numberWithCommas(parseFloat(numberWithoutComma(amount)) + parseFloat((token.fee || 0))) + ' ' + token.token"
                  :on-close="() => showReceipt = false"
                  @confirm="submit()"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <HistoryCard
              :items="items"
              :fields="fields"
              :currentpage="page"
              :total="total"
              :per-page="perPage"
              @page-change="page = $event"
            >
              <template #item(created_at)="data">
                <span>{{ getFormattedDate(data.item.automation["created_at"]) }}
                </span>
              </template>
              <template #item(status)="data">

                <span
                  :class="data.item['status'] === 'pending' ? 'text-warning' : data.item['status'] === 'success' ? 'text-success' : 'text-danger'"
                  size="sm"
                  style="display: block; width: 140px"
                >
                  {{ data.item['status'] }}
                </span>

              </template>

              <template #item(transaction_id)="data">
                <span
                  class="text-info"
                  size="sm"
                  style="display: block"
                  :disabled="!data.item.transaction_id"
                  @click="() => triggerTransactionModal(data.item)"
                >
                  {{ $t('transaction_id') }}
                </span>
              </template>
            </HistoryCard>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-row v-if="alertShow">
      <b-col sm="12">
        <dashboard-alert
          variant="success"
          :title="$t('successful-widrawModal')"
        />
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import FiatWithdraw from '@/modules/crypto/views/logic/customer-wallets/fiat/FiatWithdraw'
import DashboardAlert from '@/views/theme2/dashboard/dashboardAlert.vue'
import { numberWithoutComma } from '@/libs/helper'
import Receipt from '../../components/Receipt.vue'
import HistoryCard from '../../components/historyCard.vue'

export default {
  components: {
    DashboardAlert,
    Receipt,
    HistoryCard,
  },
  mixins: [FiatWithdraw],
  data() {
    return {
      numberWithoutComma,
    }
  },
}
</script>
<style scoped>
.card-border {
  border-right: 1px solid #e3e1e9;
}

.invoice-border {
  border: 1px solid #92ff92;
}
[dir=rtl] .right-selector::v-deep ul li {
  direction: rtl !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
